import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WorkflowService } from '../_services/workflow.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/core/reducers';
import { selectLatestCardValues } from 'src/app/core/events';
import { UpdateCardValues } from 'src/app/core/events/_actions/inbox.actions';
import { UserService } from '../../../../core/auth/_services';
import { TaskService } from '../../../../core/timeline/_services';
import { ContactsService, DrugService } from '../../../../core/lists/_services';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'kt-workflow-accordion-dashboard',
  templateUrl: './workflow-accordion-dashboard.component.html',
  styleUrls: ['./workflow-accordion-dashboard.component.scss'],
})
export class WorkflowAccordionDashboardComponent implements OnInit, OnDestroy, OnChanges {
  noDataAvailable: any;
  private workflowId: any;
  checkValues = null;
  private subscriptions: Subscription[] = [];
  workflowGrid;
  usersObj;
  entitiesObj = [];
  contactsObj = [];
  drugsObj = [];
  contactIds = [];
  drugIds = [];
  entitiesIds = [];
  initialEntity = [];
  listOfLastModified = [];
  @Input() filteredView;
  @Input() workflowGroupIdFromFilteredView;
  @Input() entitiesFromFilterView;
  sort = 'created,desc';
  page = 0;
  size = 10;
  @Input() statusesList;
  totalCountOfWorkflows = 0;
  @Input() filters: any = {};

  ngOnChanges(changes: SimpleChanges) {
    if (this.filteredView && this.workflowGroupIdFromFilteredView) {
      this.workflowId = this.workflowGroupIdFromFilteredView;
      this.loadWorkflows(this.sort, this.page, this.size);
    }
    if (changes.filters) {
      this.loadWorkflows(this.sort, this.page, this.size);
    }
  }

  constructor(
    public dialog: MatDialog,
    private workflowService: WorkflowService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>,
    private userService: UserService,
    private taskService: TaskService,
    private contactsService: ContactsService,
    private drugsService: DrugService,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.activatedRoute.params.subscribe((params) => {
        // load workflow in from campaign  or accordion list
        if (params.id) {
          this.workflowId = params.id;
        }
        // load workflow inside focused view
        if (this.filteredView && this.workflowGroupIdFromFilteredView) {
          this.workflowId = this.workflowGroupIdFromFilteredView;
        }
        if (this.workflowId) {
          this.loadWorkflows(this.sort, this.page, this.size);
        }
      }),
    );
    this.subscriptions.push(
      this.store.pipe(select(selectLatestCardValues)).subscribe((res) => {
        if (res && res.workflow_queue_id !== null) {
          this.checkValues = {
            workflow_action_id: res.workflow_action_id,
            workflow_queue_id: res.workflow_queue_id,
          };
          this.store.dispatch(
            new UpdateCardValues({
              new_values: {
                group_id: null,
                workflow_queue_id: null,
                workflow_action_id: null,
              },
            }),
          );
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  loadWorkflows(sort?, page?, size?, status?) {
    if (!this.workflowId) return;
    if (this.filteredView && !this.entitiesFromFilterView) return;

    this.workflowService
      .getWorkflowsList(
        sort,
        page,
        size,
        status,
        this.workflowId,
        this.filters,
        this.filteredView,
        this.entitiesFromFilterView,
      )
      .subscribe((response) => {
        if (response.data.length === 0) {
          this.noDataAvailable = true;
        } else {
          this.noDataAvailable = false;
          this.totalCountOfWorkflows = response.count;
          this.workflowGrid = response.data;
          this.cdr.detectChanges();
          this.workflowGrid.forEach((element) => {
            this.listOfLastModified.push(element.last_modified_user);
          });
          this.workflowGrid.forEach((element) => {
            this.initialEntity.push(element.workflow_queue);
          });
          this.getEntities(this.initialEntity);
          this.userService.getUserByUserName(this.listOfLastModified).subscribe((res) => {
            this.usersObj = [];
            this.usersObj = res.pageOfItems;
          });
        }
        this.cdr.detectChanges();
      });
  }

  refreshWorkflowList(checkValues?) {
    this.checkValues = checkValues;
    this.loadWorkflows(this.sort, this.page, this.size);
    this.cdr.detectChanges();
  }

  // This for get entities column in the workflow accordion
  getEntities(data) {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < data.length; i++) {
      const obj = data[i].workflow_queue_entities;
      obj.forEach((element) => {
        if (element && element.type === 'CONTACT')
          this.contactIds = this.arrayUnique(this.contactIds.concat(element.ids));
        if (element && element.type === 'DRUG')
          this.drugIds = this.arrayUnique(this.drugIds.concat(element.ids));
        if (element && element.type !== 'DRUG' && element.type !== 'CONTACT')
          this.entitiesIds = this.arrayUnique(this.entitiesIds.concat(element.ids));
      });
    }
    if (this.entitiesIds.length > 0) {
      this.taskService.getEntities(this.entitiesIds).subscribe((res) => {
        this.entitiesObj = [];
        this.entitiesObj = res.data;
        this.cdr.detectChanges();
      });
    }
    if (this.contactIds.length > 0) {
      this.contactsService.getContactsByIds(this.contactIds).subscribe((res) => {
        this.contactsObj = [];
        this.contactsObj = res.data;
        this.cdr.detectChanges();
      });
    }
    if (this.drugIds.length > 0) {
      this.drugsService.getDrugsByIds(this.drugIds).subscribe((res) => {
        this.drugsObj = [];
        this.drugsObj = res.data;
        this.cdr.detectChanges();
      });
    }
  }

  // This for workflow accordion
  arrayUnique(array) {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
      for (let j = i + 1; j < a.length; ++j) {
        if (a[i] === a[j]) a.splice(j--, 1);
      }
    }
    return a;
  }

  // Sorting workflow accordion
  getWorkflowListSorted(sort: { prop: string; type: string }): void {
    this.sort = sort.prop + ',' + sort.type.toLowerCase();
    this.loadWorkflows(this.sort, this.page, this.size);
  }
  loadPage($event: PageEvent) {
    this.page = $event.pageIndex;
    this.size = $event.pageSize;
    this.loadWorkflows(this.sort, this.page, this.size);
  }
}
